var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasErrors)?_c('div',{staticClass:"inline-errors__wrapper text-red-600"},_vm._l((_vm.errors),function(error,index){return _c('small',{key:index,staticClass:"block mt-1"},[_vm._v(_vm._s(error))])}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }